import styled from 'styled-components';

const FooterWrapper = styled.footer`
  text-align: start;
  position: static;
  bottom: 0;
  width: 100%;
  font-family: "Pixelify Sans", sans-serif;
  display: flex;
  justify-content: flex-end;
  opacity: .7
`;

const Footer = () => {
  return (
    <FooterWrapper>
      <p>
        Copyleft © awarehouse 2025. All rights reversed.
      </p>
    </FooterWrapper>
  );
};

export default Footer;